<div class="ng-bento">
	<div [bentoBusyLoader]="isLoadingDashboardLayout" class="dashboard-bento-loader"></div>
</div>
<div class="ng-bento firm-dashboard-ng" [bentoBusyLoader]="isLoading" [style]="dashboardStyle">
	<lib-dashboard [customBackground]="background" [isEditable]="isEditable" [preferences]="preferences" (save)="onSave($event)">
		<lib-section [header]="'Onvio.ClientDashboard.Navigation.TimeAndBilling' | translate" *ngIf="licenseTimeAndExpense || licenseBilling">
			<lib-widget [header]="'Bluemoon.Practice.Widget.WIPSummary.Title' | translate" *ngIf="licenseTimeAndExpense">
				<ng-content select='[id="wip-summary"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.ARSummary.Title' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="ar-summary"]'></ng-content>
			</lib-widget>
			<lib-widget header="{{ 'Bluemoon.Practice.Widget.Agings.WIP' | translate }} {{ 'Bluemoon.Practice.Widget.Agings.Title' | translate }}" *ngIf="licenseBilling">
				<ng-content select='[id="wip-agings"]'></ng-content>
			</lib-widget>
			<lib-widget header="{{ 'Bluemoon.Practice.Widget.Agings.AR' | translate }} {{ 'Bluemoon.Practice.Widget.Agings.Title' | translate }}" *ngIf="licenseBilling">
				<ng-content select='[id="ar-agings"]'></ng-content>
			</lib-widget>
			<lib-widget [header]="'Bluemoon.Practice.Widget.KeyTotals.Title' | translate" *ngIf="licenseBilling">
				<ng-content select='[id="key-totals"]'></ng-content>
			</lib-widget>
		</lib-section>
	</lib-dashboard>
</div>
